import { httpClient } from '@/network/clientController'

/** List of associated alias for an account
@docs Não há documentação, possivel consultar no swagger
*/
export const requestAccountAssociatedAlias = payload => {
	return httpClient({
		method: 'GET',
		url: `instantTransferManagement/${payload.accountId}/alias`,
        params: payload.params,
		isCancellable: true
	})
}

/** Creates or add a new association alias for an account
@docs Não há documentação, possivel consultar no swagger
*/
export const addAccountAliasAssociation = payload => {
	return httpClient({
		method: 'POST',
		url: `instantTransferManagement/${payload.accountId}/alias`,
        data: payload.params,
		useChallengeMock: true,
		operationTypeId: '123123' /* for mocks handling of tokens */
	})
}

/** Removes an association alias of an account
@docs Não há documentação, possivel consultar no swagger
*/
export const deleteAccountAssociation = payload => {
	return httpClient({
		method: 'DELETE',
		url: `instantTransferManagement/${payload.accountId}/alias`,
        params: payload.params,
		useChallengeMock: true,
		operationTypeId: '1231234' /* for mocks handling of tokens */
	})
}

/** Edits account default alias association
@docs Não há documentação, possivel consultar no swagger
*/
export const editsAccountDefaultAliasAssociation = payload => {
	return httpClient({
		method: 'PUT',
		url: `instantTransferManagement/${payload.accountId}/alias/default`,
        params: payload.params,
		useChallengeMock: true,
		operationTypeId: '1231235' /* for mocks handling of tokens */
	})
}

/** Resend alias association token
@docs Não há documentação, possivel consultar no swagger
*/
export const resendOTPForAccountAliasAssociation = payload => {
	return httpClient({
		method: 'POST',
		url: `instantTransferManagement/${payload}/alias/resend`
	})
}

/** Get Transfers details
@docs
*/
export const checkBeneficiaryAlias = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'instantTransferManagement/alias/name',
		params: payload
	})
}
